import React, { useState } from 'react'
import { Input } from 'components/Input/Input'
import useMount from 'react-use/lib/useMount'
import http from 'axios'
import Tag from 'components/Tag'
import Button from 'components/Button'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import s from './AvailablePremiumNumbers.scss'

type IPremiumNumber = {
  number: string
  price: number
}

const getPremiumNumbers = async () =>
  http({
    method: 'GET',
    url: `api/v1/mobile-services/numbers/premium`,
  }).then(response => response.data || [])

export const AvailablePremiumNumbers = props => {
  const { clearNumber, input, change } = props

  const [query, setQuery] = useState('')
  const [premiumNumbers, setPremiumNumbers] = useState([] as IPremiumNumber[])

  useMount(async () => {
    if (!premiumNumbers.length) {
      await getPremiumNumbers().then(numbers => setPremiumNumbers(numbers))
    }
  })

  const filtered = premiumNumbers.filter(premiumNumber => premiumNumber.number.includes(query))

  return (
    <>
      <Input
        label="Search premium number"
        type="number"
        input={{
          value: query,
          onChange: e => {
            setQuery(e.target.value)
            clearNumber()
          },
        }}
        meta={{}}
      />

      {filtered.length > 0 ? (
        <div className={s.table}>
          {filtered.map((premiumNumber, index) => (
            <div
              className={cn(sLay['layout-row'], sLay['layout-align-start-center'], s.row)}
              key={index}
            >
              <span className={sLay.flex}>{premiumNumber.number}</span>

              <Tag idx={3} size="xs" style={{ marginRight: '1rem' }}>
                $35/mth + ${premiumNumber.price}/mth
              </Tag>

              <Button
                onClick={() => {
                  input.onChange(premiumNumber.number)
                  change('premiumNumberPrice', premiumNumber.price)
                }}
                type="submit"
                color="tertiary"
                size="xs"
                ghost={input.value !== premiumNumber.number}
              >
                Select
              </Button>
            </div>
          ))}
        </div>
      ) : (
        <div>No Results</div>
      )}
    </>
  )
}



// WEBPACK FOOTER //
// src/features/MobileServices/MobileServiceForm/AvailablePremiumNumbers/AvailablePremiumNumbers.tsx